export default "<span [style.visibility]=\"visibility\" class=\"red-dot glow\"></span>\r\n"